import React, { useState, useEffect, useMemo, useContext } from "react";
import Table from "../../components/tables/Table";
import { Grid, Box, Button } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { FileDownloadOutlined } from "@mui/icons-material";
import {
  gridPageCountSelector,
  gridPageSelector,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import moment from "moment";
import { DataGridStyle } from "../../components/tables/DataGridStyles";
import PaginationTable from "../../components/tables/Pagination";
import httpCommon from "../../http-common";
import { CommonContextAPI } from "../../App";
import { getSalesReport } from "../../services/SalesReport";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  totalWrapper: {
    [theme.breakpoints.up("sm")]: {
      position: "absolute",
      bottom: "0%",
      width: "65%",
    },
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: "0%",
      width: "75%",
    },
    [theme.breakpoints.down("sx")]: {
      backgroundColor: "#ff1a1a",
      height: "220px !important",
    },
    width: "100%",
    cursor: "default",
  },
  gridContainer: {
    width: "85%",
    [theme.breakpoints.down("sm")]: {
      // width: "100%",
    },
  },
  gridColumnOdd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid black",
    borderRadius: "2px",
    backgroundColor: "#F8F8F8",
    color: "#000",
    fontSize: "1rem !important",
    cursor: "default",

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      margin: "0.2rem 0px !important",
    },
    [theme.breakpoints.up("sm")]: {
      padding: "0px",
      flexDirection: "column",
    },
  },
  gridColumnEven: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    border: "1px solid black",
    borderRadius: "2px",
    backgroundColor: "#E3E7FA",
    color: "black",
    fontSize: "1rem !important",
    cursor: "default",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      margin: "0.2rem 0px !important",
    },
    [theme.breakpoints.up("sm")]: {
      padding: "0px",
      flexDirection: "column",
    },
  },
  totalCount: {
    fontSize: "1rem",
  },
  "@global": {
    "*::-webkit-scrollbar": {
      width: "0.4em",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: "#b1b1b5",
    },
  },
  search: {
    [theme.breakpoints.down("xs")]: {
      width: "60%",
    },
  },
  clearButton: {
    backgroundColor: "#7B8BD4",
    "&:hover": { backgroundColor: "#7B8BD4" },
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
      width: "44px",
    },
  },
}));

const QuickSearchToolbar = () => {
  // GET CONTEXT COMMON DATA
  const theme = useTheme();
  const smallPhone = useMediaQuery(theme.breakpoints.down("xs"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const commonData = useContext(CommonContextAPI);

  const { clearAppliedFilters } = commonData;
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
        display: "flex",
        justifyContent: "space-between",
        mb: 0.5,
      }}
    >
      <GridToolbarQuickFilter className={classes.search} />
      <Box sx={{ "& .MuiButtonBase-root": { minWidth: "32px" } }}>
        <GridToolbarExport />
        <Button
          variant="contained"
          size="small"
          className={classes.clearButton}
          onClick={clearAppliedFilters}
        >
          {isMobile ? " Clear" : " Clear Filters"}
        </Button>
      </Box>
    </Box>
  );
};

const CustomToolbar = () => {
  const commonData = useContext(CommonContextAPI);
  const { clearAppliedFilters } = commonData;
  return (
    <GridToolbarContainer
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <GridToolbarQuickFilter />
      <div>
        <GridToolbarExport />
        <Button
          variant="contained"
          size="small"
          // className={classes.clearButton}
          style={{ marginLeft: "10px", backgroundColor: "blue !importent" }}
          onClick={clearAppliedFilters}
        >
          Clear Filters
        </Button>
      </div>
    </GridToolbarContainer>
  );
};

const SalesReport1 = () => {
  const theme = useTheme();
  const smallPhone = useMediaQuery(theme.breakpoints.down("xs"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [sales, setSales] = useState([]);
  const [bindSales, setBindSales] = useState([]);
  const [bp, setBp] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [tp, setTp] = useState(0);
  const [revenue, setRevenue] = useState(0);

  const [basicPrice, setBasicPrice] = useState(0);
  const [filterBasicPrice, setFilterBasicPrice] = useState(0);

  const [CGST, setCGST] = useState(0);
  const [filterCGST, setFilterCGST] = useState();
  const [SGST, setSGST] = useState(0);
  const [filterSGST, setFilterSGST] = useState(0);

  const [totalPrice, setTotalPrice] = useState(0);
  const [filterTotalPrice, setFilterTotalPrice] = useState(0);

  const [filteredRevenue, setFilteredRevenue] = useState(0);

  const [count, setCount] = useState(0);
  const [filteredCount, setFilteredCount] = useState(0);

  // CONSTANT VALUES
  const { GST_RATE, CGST_RATE, SGST_RATE } = useSelector(
    (state) => state?.AppConstants
  );

  const commonURL = httpCommon.defaults.baseURL;

  // GET CONTEXT COMMON DATA
  const commonData = useContext(CommonContextAPI);

  const {
    downloadXLS,
    handleOpenDatePicker,
    filteredDate,
    filterDateRenge,
    filterDateInRange,
    filterModel,
    getCachedData,
    storeDataInCache,
    defaultDate,
  } = commonData;

  const [filter, setFilter] = useState([]);


   // Function to handle the icon click event
  //  const handleIconClick = async (orderId) => {
  //   try {
  //     const response = await axios.get(`https://testapi.gativan.in/api/invoice?id=${orderId}`);
  //     console.log("API Response:", response.data);
  //   } catch (error) {
  //     console.error("Error occurred while fetching data:", error);
  //   }
  // };







  const columns = [
    {
      field: "orderId",
      headerName: "Order ID",
      headerClassName: "super-app-theme--header",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      headerClassName: "super-app-theme--header",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "bookingMode",
      headerName: "Booking Mode",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      flex: 1,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      flex: 1,
    },
    {
      field: "completedDate",
      headerName: "Completed Date",
      headerClassName: "super-app-theme--header",
      minWidth: 140,
      filterable: true,
      editable: true,
      filterOperators: filterDateInRange,
      flex: 1,
    },
    {
      field: "vehicleType",
      headerName: "Vehicle Type",
      headerClassName: "super-app-theme--header",
      minWidth: 110,
      flex: 1,
    },
    {
      field: "basicPrice",
      headerName: "Basic_Price",
      headerClassName: "super-app-theme--header",
      filterable: true,
      editable: true,
      minWidth: 160,
      flex: 1,
    },
    {
      field: "cgst",
      headerName: "CGST",
      headerClassName: "super-app-theme--header",
      minWidth: 124,
    },
    {
      field: "sgst",
      headerName: "SGST",
      headerClassName: "super-app-theme--header",
      minWidth: 124,
      flex: 1,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "sales",
      headerName: "Sales",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "paymentMode",
      headerName: "Payment Mode",
      headerClassName: "super-app-theme--header",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "invoiceNumber",
      headerName: "Invoice Number",
      headerClassName: "super-app-theme--header",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "gstn",
      headerName: "GST Number",
      headerClassName: "super-app-theme--header",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      headerClassName: "super-app-theme--header",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "vehicleNumber",
      headerName: "Vehicle Number",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "serviceAdvisor",
      headerName: "Service Advisor",
      headerClassName: "super-app-theme--header",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "garageName",
      headerName: "Garage Name",
      headerClassName: "super-app-theme--header",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "orderType",
      headerName: "Order Type",
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "codeOfInsurance",
      headerName: "Code Of Insurance",
      headerClassName: "super-app-theme--header",
      minWidth: 160,
      flex: 1,
      // renderCell: (params) => params.row.codeOfInsurance?.code || ""
    },
    
    
    // {
    //   field: "Gativan1",
    //   headerName: "PDF Download",
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 130,
    //   flex: 1,
    //   renderCell: (params) => (
    //     <Grid container alignItems="center" justifyContent="center">
    //       <FileDownloadOutlined
    //         style={{ cursor: "pointer" }}
    //         // onClick={() => handleIconClick(params.row.orderId)} 
    //         onClick={() => handleIconClick(params.row.orderId)} 
    //       />
    //     </Grid>
    //   ),
    // },

      {
        field: "gst18",
        headerName: "18% GST",
        headerClassName: "super-app-theme--header",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "gst28",
        headerName: "28% GST",
        headerClassName: "super-app-theme--header",
        minWidth: 120,
        flex: 1,
      },
  ];

  useMemo(() => {
    const totalsales = bindSales
      ?.map((i) => i.sales)
      .reduce((a, b) => a + b, 0);
    setRevenue(totalsales);
    const totalCGST = bindSales?.map((i) => i.cgst).reduce((a, b) => a + b, 0);
    setCGST(totalCGST);

    const totalSGST = bindSales?.map((i) => i.sgst).reduce((a, b) => a + b, 0);
    setSGST(totalSGST);

    const totalBasic = bindSales
      ?.map((i) => i.basicPrice)
      ?.reduce((a, b) => a + b, 0);
    setBasicPrice(totalBasic);

    const totalP = bindSales
      ?.map((i) => i.totalPrice)
      .reduce((a, b) => a + b, 0);
    setTotalPrice(totalP);
    setCount(bindSales?.length);
  }, [bindSales]);

  // Get all orders.
  const localData = JSON.parse(localStorage.getItem("loginDetails"));

  const getSalesreport = async () => {
    setSales([]);
    setBindSales([]);
    let startDate;
    let endDate;

    if (filteredDate) {
      startDate =
        filteredDate && moment(filteredDate[0]?.startDate).format("YYYY-MM-DD");
      endDate =
        filteredDate && moment(filteredDate[0]?.endDate).format("YYYY-MM-DD");
    } else {
      startDate =
        defaultDate && moment(defaultDate[0]?.startDate).format("YYYY-MM-DD");
      endDate =
        defaultDate && moment(defaultDate[0]?.endDate).format("YYYY-MM-DD");
    }

    const config = {
      headers: {
        Authorization: `Bearer ${localData?.jwtToken}`,
      },
      // params: { all: true },
      params: { from: startDate, to: endDate },
    };

    try {
      const request = await getSalesReport(config);
      const response = await request.data;
      setSales(response?.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    setSales([]);

    if (defaultDate || filteredDate) {
      getSalesreport();
      setLoading(true);
    }
  }, [, defaultDate, filteredDate]);

  useEffect(() => {
    setBindSales([]);
    sales?.map((sale) => {
      const obj = {
        ...sale,
        bookingMode: sale?.orderBookingMode?.mode,
        vehicleType: sale?.vehicle?.vehicleType,
        codeOfInsurance:sale?.codeOfInsurance?.code,
      };

      setBindSales((prev) => [...prev, obj]);
    });
  }, [sales]);

  // Date filter model
  useMemo(() => {
    filteredDate && filterDateRenge && filterDateRenge("completedDate");
  }, [filteredDate && filteredDate]);

  function FooterSection() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <div className="grid-table-footer">
        <div className="grid-table-footer-right">
          <div style={{ marginLeft: "10px" }}>
            <h5 className="grid-table-footer-right-label">
              Count :{" "}
              <span className="grid-table-footer-right-value">
                {filteredCount ? filteredCount : count}
              </span>
            </h5>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <h5 className="grid-table-footer-right-label">
              Basic Price :{" "}
              <span className="grid-table-footer-right-value">
                {filterBasicPrice
                  ? filterBasicPrice?.toFixed(2)
                  : basicPrice?.toFixed(2)}
              </span>
            </h5>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <h5 className="grid-table-footer-right-label">
              CGST :{" "}
              <span className="grid-table-footer-right-value">
                {filterCGST >= 1 ? filterCGST?.toFixed(2) : CGST?.toFixed(2)}
              </span>
            </h5>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <h5 className="grid-table-footer-right-label">
              SGST :{" "}
              <span className="grid-table-footer-right-value">
                {filterSGST ? filterSGST?.toFixed(2) : SGST?.toFixed(2)}
              </span>
            </h5>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <h5 className="grid-table-footer-right-label">
              Total Price :{" "}
              <span className="grid-table-footer-right-value">
                {filterTotalPrice
                  ? filterTotalPrice?.toFixed(2)
                  : totalPrice?.toFixed(2)}
              </span>
            </h5>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <h5 className="grid-table-footer-right-label">
              Revenue:{" "}
              <span className="grid-table-footer-right-value">
                {filteredRevenue >= 1
                  ? filteredRevenue?.toFixed(2)
                  : revenue?.toFixed(2)}
              </span>
            </h5>
          </div>
        </div>
        <PaginationTable />
      </div>
    );
  }

  const style = {
    "& .super-app-theme--false": {
      backgroundColor: "#D0342C",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#D0342C",
        color: "#fff",
      },
    },
  };

  return (
    <Box>
      <Table
        customStyle={{ ...DataGridStyle, ...style }}
        rows={bindSales}
        columns={columns}
        heading="Sales Report 1"
        pageSize={50}
        rowsPerPageOptions={[100]}
        initialState={{
          sorting: {
            sortModel: [{ field: "completedDate", sort: "desc" }],
          },
        }}
        onStateChange={(state) => {
          const visibleRows = state.filter.visibleRowsLookup;
          let visibleItems = [];
          for (const [invoiceNumber, value] of Object.entries(visibleRows)) {
            if (value === true) {
              visibleItems.push(invoiceNumber);
            }
          }
          const res = bindSales.filter((item) =>
            visibleItems.includes(item.invoiceNumber)
          );
          const salesT = res
            ?.map((i) => i.bindSales)
            .reduce((a, b) => a + b, 0);
          const cgst = res?.map((i) => i.cgst).reduce((a, b) => a + b, 0);
          const basicPrice = res
            ?.map((i) => i.basicPrice)
            ?.reduce((a, b) => a + b, 0);
          const sgst = res?.map((i) => i.sgst).reduce((a, b) => a + b, 0);
          const total = res
            ?.map((i) => i.totalPrice)
            .reduce((a, b) => a + b, 0);

          setFilter(res > 0 && res);
          setFilterTotalPrice(total > 0 && total);
          setFilterSGST(sgst > 0 && sgst);
          setFilterBasicPrice(basicPrice > 0 && basicPrice);
          setFilteredRevenue(salesT > 0 && salesT);
          setFilterCGST(cgst > 0 && cgst);
          setFilteredCount(res?.length > 0 && res?.length);
        }}
        filterModel={filterModel && filterModel}
        // total={totalsconst commonData = useContext(CommonContextAPI);}
        loading={loading}
        downloadXLS={() => downloadXLS(filter.length > 0 ? filter : bindSales)}
        components={{ Footer: FooterSection, Toolbar: QuickSearchToolbar }}
        handleOpenDatePicker={handleOpenDatePicker}
        filteredDate={filteredDate}
        getRowId={(row) => row?.orderId}
        getRowClassName={(params) => `super-app-theme--${params.row.isInvoice}`}
      />
    </Box>
  );
};

export default SalesReport1;
